import { useContext } from "react";

import {
  SupportChatContext,
  SupportChatContextValue,
} from "./SupportChatProvider";

export const useSupportChat = (): SupportChatContextValue => {
  const context = useContext(SupportChatContext);

  if (context === undefined) {
    throw new Error("useSupportChat must be used within a SupportChatProvider");
  }

  return context;
};
